/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RedirectService } from '../redirect/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class GatekeeperService {
  constructor(private readonly http: HttpClient, private readonly router: Router, private readonly redirectService: RedirectService) { }

  public isFeatureSwitchedOn(featureId: string): Observable<boolean> {
    const url = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.GATEKEEPER_URL}/${featureId}`;
    return this.http
      .get<any>(url)
      .pipe(
        map((isToggle) => {
          return isToggle;
        }),
        catchError(() => {
          return of(false);
        }),
      );
  }

  public redirectToModernizedApp(): void {
    this.router.navigate(['']);
  }

  getGatekeeperFlag() {
    // Don't run gatekeeper redirect logic on internal routes
    const currentPath = window.location.pathname;
    if (currentPath.includes('/send-confirmation')) {
      console.log('Gatekeeper: Skipping redirect logic for internal route:', currentPath);
      return;
    }

    this.isFeatureSwitchedOn(environment.GATEKEEPER_FEATURE_ID).toPromise()
      .then((response: boolean) => {
        console.log('Gatekeeper response:', response, 'Current path:', currentPath);
        if (response) {
          // redirect to legacy if gatekeeper is set to true
          // document.location.href = environment.LEGACY_URL + '?redirect=true';
          const legacyUrl = new URL(environment.LEGACY_URL);
          if (environment.internal) {
            legacyUrl.port = window.location.port;
          }
          legacyUrl.pathname = environment.LEGACY_URL_PATH;
          legacyUrl.searchParams.append('redirect', 'true');
          this.redirectService.redirectTo(legacyUrl.toString());
          console.log('Redirecting to Legacy URL', legacyUrl.toString());
        } else {
          console.log('Gatekeeper: Would redirect to modernized app, but checking if on internal route');
          const currentPathAtRedirect = window.location.pathname;
          if (!currentPathAtRedirect.includes('/send-confirmation')) {
            this.redirectToModernizedApp();
          } else {
            console.log('Gatekeeper: Skipping redirect to home because user is on send-confirmation page');
          }
        }
      }).catch((err) => {
        console.log('Gatekeeper catch block', err);
      })
  }
  /**
   * Future scope for gatekeeper
   */
  // public isFeaturesMultipleSwitchedOn(
  //   featureIds: string[],
  // ): Observable<{ [key: string]: boolean }> {
  //   const url = environment['gatekeeper'];
  //   return this.http
  //     .get<any>(`${url}/multi`, {
  //       params: { featureId: featureIds.join(',') },
  //       withCredentials: true,
  //     })
  //     .pipe(
  //       map((featureList) => {
  //         const featureMap = {};
  //         for (let i = 0; i < featureList.length; i++) {
  //           featureMap[featureList[i].featureId] = featureList[i].enabled;
  //         }
  //         return featureMap;
  //       }),
  //       catchError(() => {
  //         const data = {};
  //         for (let i = 0; i < featureIds.length; i++) {
  //           data[featureIds[i]] = false;
  //         }
  //         return of(data);
  //       }),
  //     );
  // }
}
